import axios from "axios"

export default axios.create({
    baseURL: "https://webhooks.mongodb-realm.com/api/client/v2.0/app/dinorealm-dqist/service/dinomension/incoming_webhook/",
    headers: {
        "Content-type" : "application/json"
    }
})